import { Middleware } from '@reduxjs/toolkit'
import {
  nextTheme,
  reloadThemeStyle,
  toggleTheme,
} from '../../features/setting/setting.slice.ts'
import { RootState } from '../store.ts'

// Keeps the theme side effects out of the reducer. They must run BEFORE
// next(action): that call notifies subscribers synchronously, and consumers of
// selectThemeStyle would otherwise read the previous theme's values. The DOM
// attribute is set first because reloadThemeStyle() reads data-theme back off
// the document.
export const themeMiddleware: Middleware = (store) => (next) => (action) => {
  if (toggleTheme.match(action)) {
    const applied = nextTheme((store.getState() as RootState).setting.theme)
    document.documentElement.setAttribute('data-theme', applied)
    localStorage.setItem('colorTheme', applied)
    reloadThemeStyle()
  }

  return next(action)
}
